import i18n from '../../../i18n';

const getDefaultState = () => ({
  items: [
    {
      subheading: i18n.t('navigationSubheadings.general'),
      pages: [
        {
          title: i18n.t('pages.dashboard'),
          to: { name: 'Dashboard' },
          icon: 'ballot',
        },
        {
          title: i18n.t('pages.twenty'),
          href: process.env.TWENTY_FRONT_PAGE,
          icon: 'launch',
        },
      ],
    },
    {
      subheading: i18n.t('navigationSubheadings.webContent'),
      pages: [
        {
          title: 'Review',
          to: { name: 'ReviewWrapper' },
          icon: 'ballot',
        },
        {
          title: i18n.t('pages.reviewSettings'),
          to: { name: 'ReviewSettingsWrapper' },
          icon: 'settings',
        },
      ],
    },
  ],
});

export default getDefaultState;



// WEBPACK FOOTER //
// ./src/store/modules/nav/defaultState.js